(function(){
  var cache = {};
  function getProduct(handle){
    if (!cache[handle]) cache[handle] = fetch('/products/' + handle + '.js').then(function(r){ return r.json(); });
    return cache[handle];
  }
  function sized(url, w){ return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function srcset(url){
    return [165,360,533,720,940,1066,1500].map(function(w){ return sized(url, w) + ' ' + w + 'w'; }).join(',');
  }
  document.addEventListener('click', function(e){
    var label = e.target.closest && e.target.closest('.m-product-card [data-option-type="color"]');
    if (!label) return;
    var card = label.closest('.m-product-card');
    var link = card && card.querySelector('a[href*="/products/"]');
    if (!link) return;
    var handle = link.getAttribute('href').split('/products/')[1].split(/[?#]/)[0];
    var color = label.getAttribute('data-value');
    var pos = parseInt(label.getAttribute('data-option-position') || '1', 10);
    getProduct(handle).then(function(p){
      var v = p.variants.filter(function(x){ return x['option' + pos] === color && x.available; })[0]
           || p.variants.filter(function(x){ return x['option' + pos] === color; })[0];
      if (!v) return;
      setTimeout(function(){
        card.querySelectorAll('a[href*="/products/' + handle + '"]').forEach(function(a){
          a.setAttribute('href', '/products/' + handle + '?variant=' + v.id);
        });
        if (v.featured_image) {
          var i = v.featured_image.position;
          var next = p.images[i];
          var hover = card.querySelector('.m-product-card__hover-image img');
          if (hover && next) { hover.removeAttribute('src'); hover.setAttribute('srcset', srcset(next)); }
        }
      }, 60);
    });
  });
})();
